import { DataSources } from '@leverege/ui-attributes';
import { GroupDelegate, Relationship } from '@leverege/molten-core';
const EMPTY = {};

/**
 * Returns { relationship, match } for the parent relationship used to set
 * the attribute.
 */
function getGroupRelationship(objRef, attr) {
  if (!objRef || !objRef.ref) {
    return null;
  }
  const {
    type,
    ref,
    id
  } = objRef;
  const lookupRef = ref.replace(`/${id}`, '');
  const lookupType = type;
  const delegate = DataSources.getDelegate({
    ...objRef,
    ref: lookupRef,
    type: lookupType
  }) || EMPTY;
  const {
    relationship,
    match
  } = delegate;

  // Given the obj's location in the relationship tree, look up the
  // location to find the possible parents
  if (relationship) {
    const srcs = attr?.source?.attribute?.metadata?.setter?.parentSources;
    if (srcs) {
      const src = srcs.find(d => d.path === relationship.path);
      if (src && src.sourcePath) {
        const rel = Relationship.getByPath(src.sourcePath);
        if (rel) {
          return {
            relationship: rel.createResolved(match),
            match,
            filter: src.filter,
            queryName: `parentRel-${src.sourcePath}`,
            objectType: rel.options.objectType
          };
        }
      }
    }
  }
  return null;
}
function getGroupDelegate(objRef, attr) {
  const rel = getGroupRelationship(objRef, attr);
  return rel ? new GroupDelegate({
    ...rel,
    ttl: 300000
  }) : null;
}
export default {
  getGroupDelegate,
  getGroupRelationship
};